import { ColumnSettings, ITableColumn } from '@makyoapp/makyo-sdk/models/Table'

import { Cell, ICell, ICellError } from '.'

export type AdrType = 'street' | 'plus-code'

export interface IAddressColumnSettings extends ColumnSettings {
  adrType: AdrType
}

export interface IAddressColumn extends ITableColumn {
  Settings: IAddressColumnSettings
}

export interface IAddressCell extends ICell {
  settings: IAddressColumnSettings
}

export class AddressCell implements IAddressCell {
  value: Cell
  settings: IAddressColumnSettings

  constructor(value: Cell, settings: IAddressColumnSettings) {
    this.value = value
    this.settings = settings
  }

  toString(): string {
    const { adrType } = this.settings

    if (this.value instanceof Date) {
      return this.value.toISOString()
    }

    if (typeof this.value === 'object' && this.value !== null && 'message' in this.value) {
      return (this.value as ICellError).message // Assuming ICellError has a message property
    }

    if (typeof this.value === 'string' || typeof this.value === 'number' || typeof this.value === 'boolean') {
      return this.value.toString()
    }

    // Default case for null or unsupported types
    return ''
  }

  toCell<T extends Cell>(value: T) {
    if (!value || typeof value !== 'string') {
      this.value = ''
      return this
    }
    this.value = value
    return this
  }
}
